import { httpGet, httpPost } from "@eres/rest";
import { I8N, LocaleUtil } from "@eres/core";
import cfg from "./config";
import { ExValLookUp, ValidationError } from "./entities";

export interface TRResponse<T> {
	Code: number | string;
	Message: string;
	Response: T;
}

export function loadLookUp( lookUp: ExValLookUp ) {
	return httpGet( cfg.taqyimeeAPI().endPoint() + "Lookup?lookupRequest.lookupType=" + `${ lookUp }` ).then( resp => {
		return checkValidationError( resp );
	} );
}

export function getAuthorities() {
	return httpGet( cfg.taqyimeeAPI().endPoint() + "Authority" );
}

export function getValuationClassificationDetails( valuationNumber: number, year: any, type: string ) {
	return httpGet( cfg.classificationRankAPI().endPoint() + "valuation/office/classification/detail/verified?realEstateNumber=" + valuationNumber + "&rankYear=" + year );
}

export function submitTabuEvaluationRequest( evaluationRequest: any ) {
	return httpPost( cfg.taqyimeeAPI().endPoint() + "RequestEvaluation/SubmitTabuRequest", evaluationRequest.toString(), undefined );
}

export function getOwnerRequests() {
	return httpGet( cfg.taqyimeeAPI().endPoint() + "RequestEvaluation/Search/Owner?pageSize=2000" );
}

export function getValuationDetailsByRequestID( requestId: any ) {
	return httpGet( cfg.taqyimeeAPI().endPoint() + "RequestEvaluation/request/detail?requestId=" + requestId );
}

export function downloadOfficeCertificate( realStateNumber: string ) {
	return httpGet( cfg.trakheesiCertAPI().endPoint() + `print/office/detail/pdf/binary?realEstateNumber=${ realStateNumber }` );
}

export function checkApiResponseError( response: any ): Promise<any> {
	if ( response ) {
		if ( response.responseCode != undefined && response.responseCode + "" === "Success" ) {
			return response.response;
		} else {
			if ( response.Message != undefined ) {
				return Promise.reject( response.Message );
			} else {
				return Promise.reject( "Error " + response.Code );
			}
		}
	} else {
		return Promise.reject( "Empty response from Server" );
	}
}

export function getValidationError( errors: ValidationError[] ) {
	let errorMsg = errors.map( ( error: ValidationError ) => {
		if ( error.errorMessage ) {
			return error.errorMessage;
		} else {
			if ( error.MessageAr || error.MessageEn ) {
				return I8N.locale() === "ar" ? error.MessageAr : error.MessageEn;
			} else if ( error.ErrorMessageAr || error.ErrorMessageEn ) {
				return I8N.locale() === "ar" ? error.ErrorMessageAr : error.ErrorMessageEn;
			}
		}
	} );
	return errorMsg.join( "\n" );
}

function checkValidationError( response: any, key: string = "validationErrorsList" ): Promise<any> {
	if ( response ) {
		if ( response.hasOwnProperty( key ) ) {
			let errors = response[ key ];
			if ( errors != undefined && Array.isArray( errors ) && errors.length > 0 ) {
				let message = errors.map( e => e.errorMessageSet ? LocaleUtil.getLocalValue( e.errorMessageSet ) : e.errorMessage ).join( "\n" ).trim();
				let errorNumbers = errors.filter( e => e.errorNumber === 410010 );
				return Promise.reject( {
					type: "ValidationError",
					response: response && response.response ? response.response : undefined,
					errors: errors,
					message: message,
					errorNumbers: errorNumbers,
				} );
			}
		}
	}
	if ( response.response ) return response.response;
	return response;
}
